// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

// uncomment this when we want sentry to be active

// import * as Sentry from '@sentry/nextjs';

// if (process.env.NEXT_PUBLIC_ENV === 'production') {
//   Sentry.init({
//     dsn: 'https://c60bd58f946c873f891595905f79e95d@o4508143017000960.ingest.de.sentry.io/4509009071439952',

//     integrations: [Sentry.replayIntegration()],

//     tracesSampleRate: 1,

//     replaysSessionSampleRate: 0.1,

//     replaysOnErrorSampleRate: 1.0,

//     // Setting this option to true will print useful information to the console while you're setting up Sentry.
//     debug: false,
//   });
// }

// export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
